import React, { useState } from "react";
import { Icon } from "@iconify/react";
const items: string[] = ["All", "Senior Nurse", "Nurse", "HCA"];
const showDot = true;
interface Props {
  setSelectedFilter: (designation: string) => void;
}
const TrackingTabs: React.FC<Props> = ({ setSelectedFilter }) => {
  const [selectedButton, setSelectedButton] = useState(
    items && items.length > 0 ? items[0] : null
  );

  const handleButtonClick = (button: any) => {
    setSelectedButton(button);
    if (button == "Nurse") {
      setSelectedFilter("nurse");
      // fetchScheduleByDayForNurse();
    } else if (button == "HCA") {
      setSelectedFilter("HCA");
      // fetchScheduleByDayForHCA();
    } else if (button == "Senior Nurse") {
      setSelectedFilter("senior nurse");
    } else {
      setSelectedFilter("All");
      // allEmployeesFilter();
    }
  };

  // Check if items exist and is an array
  if (!items || !Array.isArray(items)) {
    return null; // Return null or a fallback component if items is invalid
  }
  const getButtonDotColor = (item: string) => {
    if (item === "Senior Nurse") {
      return "dodoria";
    } else if (item === "Nurse") {
      return "whis";
    } else if (item === "HCA") {
      return "krillin";
    }
    return "black";
  };
  return (
    <div className="flex items-center justify-center w-fit gap-1 p-1 bg-goku rounded-moon-s-sm">
      {items.map((item, index) => (
        <button
          key={index}
          className={`px-3 py-1 gap-1 flex items-center justify-center w-full font-regular whitespace-nowrap text-moon-14  rounded-moon-i-sm transition-colors cursor-pointer hover:bg-gohan focus:outline-none ${
            selectedButton === item
              ? "bg-gohan text-slate-900 font-semibold"
              : "text-trunks font-regular"
          }`}
          onClick={() => {
            handleButtonClick(item);
          }}
        >
          {item !== "All" && showDot && (
            <span className={`dot text-${getButtonDotColor(item)}`}>
              <Icon icon="material-symbols:circle" />
            </span>
          )}

          {item}
        </button>
      ))}
    </div>
  );
};

export default TrackingTabs;
